import React from 'react'
import { Link } from 'react-router-dom'
import { FreePlanCard, PremiumPlanCard } from '../components/PricingPlans'
import GuestHeader from '../components/GuestHeader'

export default function PlanSelectionPage() {
  return (
    <div className="min-h-screen bg-paper">
      <GuestHeader />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="mb-8 sm:mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-ink mb-3">Pick a plan</h1>
          <p className="text-lg text-muted max-w-xl">
            Start free. Upgrade later if you add more vehicles or want receipts and reports.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
          <FreePlanCard variant="selection" linkTo="/register/free" />
          <PremiumPlanCard variant="selection" linkTo="/register/premium" />
        </div>

        <p className="mt-8 text-sm text-muted">
          Already have an account?{' '}
          <Link to="/login" className="font-bold text-accent hover:text-accent-dark">Sign in</Link>
        </p>
      </div>
    </div>
  )
}
